import React from 'react';
import PropTypes from 'prop-types';

import BonusValue from './BonusValue';

import {
  Badge,
  BadgeText,
  Headline,
  HeadlineGroup,
  MobileBlock,
  MobileGainRow,
  MobileGainText,
  MobileHeadline,
  PromoSection,
} from './styles';

const PromoContent = ({ bonusAmount, badgeText, durationHoursLabel }) => (
  <PromoSection data-node-id="2242:5439">
    <HeadlineGroup data-node-id="2242:5440">
      <Headline data-node-id="2242:5441">
        Faça a 1ª oferta em {durationHoursLabel}h e ganhe
      </Headline>
      <BonusValue amount={bonusAmount} />
    </HeadlineGroup>

    <MobileBlock>
      <MobileHeadline>Faça sua 1ª oferta em {durationHoursLabel}H</MobileHeadline>
      <MobileGainRow>
        <MobileGainText>Ganhe</MobileGainText>
        <BonusValue amount={bonusAmount} />
      </MobileGainRow>
    </MobileBlock>

    <Badge data-node-id="2242:5446">
      <BadgeText data-node-id="2242:5447">{badgeText}</BadgeText>
    </Badge>
  </PromoSection>
);

PromoContent.propTypes = {
  bonusAmount: PropTypes.string.isRequired,
  badgeText: PropTypes.string.isRequired,
  durationHoursLabel: PropTypes.string.isRequired,
};

export default PromoContent;
